import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';

import { FieldType } from '..';
import { ImageService } from '../../../services/imageService';
import placeholder from '../../../static/images/image-placeholder.png';
import { InputValidationResult } from '../..';
import { apiTranslate } from '../../../translations/translations';

type ImageFieldInputProps = {
  field: FieldType;
  value?: string;
  disabled?: boolean;
  onChangeValidator: (value: string) => InputValidationResult;
};

const useStyles = makeStyles((theme) => ({
  photo: {
    width: '100%',
    height: 'auto',
    paddingBottom: theme.spacing(2),
  },
}));

const ImageField: React.FC<ImageFieldInputProps> = (props) => {
  const { field, value, disabled, onChangeValidator } = props;

  const { t } = useTranslation(['translations']);

  const classes = useStyles();

  const [photoImageData, setPhotoImageData] = useState<string>();

  useEffect(() => {
    setPhotoImageData(value);
  }, [value]);

  const takePhotoChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      if (file) {
        ImageService.getImageDataFromFileAndResizeIfNeeded(file).then(
          (imageData: string) => {
            setPhotoImageData(imageData);

            if (onChangeValidator) {
              onChangeValidator(imageData);
            }
          },
        );
      } else {
        if (onChangeValidator) {
          onChangeValidator('');
        }
      }
    }
  };

  return (
    <>
      <Typography>{apiTranslate(field.title)}</Typography>
      <Box>
        <img src={photoImageData ?? placeholder} className={classes.photo} />
      </Box>
      {disabled !== true && (
        <Button
          variant="contained"
          color="primary"
          component="label"
          size="large"
          fullWidth
          startIcon={<AddAPhotoIcon />}
        >
          {t('registration_page.take_photo')}
          <input
            type="file"
            accept="image/*"
            id="image-upload"
            onChange={takePhotoChanged}
            capture
            hidden
          />
        </Button>
      )}
    </>
  );
};

export { ImageField };
